import { createApp } from 'vue'
import App from './App.vue'
import { createI18n } from 'vue-i18n'
import router from './router' // <---
import store from './store'

import './styles/reset.css'

const i18n = createI18n({
  locale: "en",
  messages: {
    en: {
      login: {
        label: 'Enter your password',
        submit: 'ok',
        // errorMessage: 'Hello, please connect later to the experience.',
        errorMessage: 'Wrong password!'
      },
      message: {
        notfound: "Oops, it looks like the page you're looking for doesn't exist.",
        hello: "hello wzzorld!"
      },
      welcome: {
        h11: "Welcome to the",
        h12: "digital event!",
        rule1: "Enjoy the experience by moving 360° in the landscape.",
        text: "Click on the highlighted points of interest<br>to discover exclusive content.",
        btn: "start the journey"
      },
      end: {
        text: "Thank you very much for participating in the experiment!<br>We hope that this journey has been inspiring and refreshing for you.",
        qrcode: "We invite you to visit the landing page by scanning this QR code.",
        restart: "Restart the journey",
        restartr1: "Restart room 1",
        restartr2: "Restart room 2",
      },
      fallback: "Please access this experience via your computer to fully enjoy the journey!",
      keypointsTitles: {
        r11: "Orin Hardy interview",
        r12: "Making Of",
        r13: "Orin Hardy engaged project",
        r21: "Our eco-responsibility",
        r22: "Fragrance with Quentin Bisch, Perfumer",
      }
    },
    fr: {
      login: {
        label: 'Mot de passe',
        submit: 'ok',
        errorMessage: 'Mauvais mot de passe'
      },
      message: {
        notfound: "Oups, la page que vous recherchez n'existe pas.",
        hello: "bonjour world!"
      },
      welcome: {
        h11: "bienvenue à la",
        h12: "digital event!",
        text: "Enjoy the experience by moving 360° in the landscape.<br><br>Click on the highlighted points of interest to discover exclusive content.",
        btn: "start the journey"
      },
      end: {
        text: "Thank you very much for participating in the experiment!<br><br>We hope that this journey has been inspiring and refreshing for you.",
        qrcode: "We invite you to visit the landing page by scanning this QR code.",
        restart: "Restart the journey",
        restartr1: "Restart room 1",
        restartr2: "Restart room 2",
      }
    },
  }
});


createApp(App)
  .provide('store', store)
  .use(router)
  .use(i18n)
  .mount('#app')
